import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
  HostBinding,
  ViewChild,
  forwardRef,
} from '@angular/core';
import { StreetAddress } from '../../models/streetAddress/streetAddress';
import { FloatLabelType } from '@angular/material/form-field';
import {
  TextInputComponent,
  TextModes,
} from '../ui/controls/text-input/text-input.component';
import {
  DdlInputComponent,
  DDLModes,
} from '../ui/controls/ddl-input/ddl-input.component';
import { iValidatedControl } from '../ui/controls/iValidatedControl';
import {
  FormValidator,
  ValidationMessage,
} from '../../models/validation/formValidator';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CacheService } from '../../core/storage/cacheService';
import { ListItem } from '../../../../../../libs/Shared/components/model/listItem';

@Component({
  selector: 'app-street-address',
  templateUrl: './street-address.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StreetAddressComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class StreetAddressComponent implements ControlValueAccessor {
  @HostBinding('class.formField') formFieldClass = true; // Always applied
  @HostBinding('class.readOnly') get isReadOnly() {
    return this.readonly;
  }

  @Input() streetAddress: Partial<StreetAddress> | undefined =
    StreetAddress.createEmpty();
  @Input() enableEditing: boolean = false;
  //@Input() mode: string = "view";
  @Input() readonly: boolean = false;
  @Input() enableDataStore: boolean = false;
  @Input() addressLabel: string = 'Address';
  @Input() showRequired: boolean = false;
  @Output() addressUpdated: EventEmitter<Partial<StreetAddress>> =
    new EventEmitter<Partial<StreetAddress>>();

  @ViewChild('ddlState') ddlState: DdlInputComponent | undefined = undefined;
  @ViewChild('txtPostalCode') txtPostalCode: TextInputComponent | undefined =
    undefined;
  @ViewChildren(TextInputComponent) validatedTextBoxes:
    | QueryList<TextInputComponent>
    | undefined;
  @ViewChildren(DdlInputComponent) validatedDropDowns:
    | QueryList<DdlInputComponent>
    | undefined;

  onChange = (_: any) => {};
  onTouched = () => {};
  writeValue(s: StreetAddress): void {
    if (s != null) {
      this.streetAddress = s;
      this.data = s;

      if (this.ddlState && this.data.country) {
        this.ddlState.lookupOptions(this.data.country);
      }
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  data: Partial<StreetAddress> = StreetAddress.createEmpty();
  selectedCountry: string = '';
  stateLabel: string = 'State/Province';

  // states = [{n:"Missouri", a:"MO"}]

  // countryOptions: ListItem[]
  // stateOptions: ListItem[]

  inputTextModes = TextModes;
  DDLModes = DDLModes;

  countryOptions: ListItem[] = [];
  stateOptions: ListItem[] = [];

  constructor(private formValidator: FormValidator, private cache: CacheService) {
    this.streetAddress = StreetAddress.createEmpty();

    // this.countryOptions = [
    //   new ListItem({ name: "United States", id: "US" }),
    //   new ListItem({ name: "Canada", id: "CA" })
    // ]
    // this.stateOptions = [new ListItem({name:"Alabama",id:"AL"}), new ListItem({name:"Alaska",id:"AK"}), new ListItem({name:"Arizona",id:"AZ"}), new ListItem({name:"Arkansas",id:"AR"}), new ListItem({name:"American Samoa",id:"AS"}), new ListItem({name:"California",id:"CA"}), new ListItem({name:"Colorado",id:"CO"}), new ListItem({name:"Connecticut",id:"CT"}), new ListItem({name:"Delaware",id:"DE"}), new ListItem({name:"District of Columbia",id:"DC"}), new ListItem({name:"Florida",id:"FL"}), new ListItem({name:"Georgia",id:"GA"}), new ListItem({name:"Guam",id:"GU"}), new ListItem({name:"Hawaii",id:"HI"}), new ListItem({name:"Idaho",id:"ID"}), new ListItem({name:"Illinois",id:"IL"}), new ListItem({name:"Indiana",id:"IN"}), new ListItem({name:"Iowa",id:"IA"}), new ListItem({name:"Kansas",id:"KS"}), new ListItem({name:"Kentucky",id:"KY"}), new ListItem({name:"Louisiana",id:"LA"}), new ListItem({name:"Maine",id:"ME"}), new ListItem({name:"Maryland",id:"MD"}), new ListItem({name:"Massachusetts",id:"MA"}), new ListItem({name:"Michigan",id:"MI"}), new ListItem({name:"Minnesota",id:"MN"}), new ListItem({name:"Mississippi",id:"MS"}), new ListItem({name:"Missouri",id:"MO"}), new ListItem({name:"Montana",id:"MT"}), new ListItem({name:"Nebraska",id:"NE"}), new ListItem({name:"Nevada",id:"NV"}), new ListItem({name:"New Hampshire",id:"NH"}), new ListItem({name:"New Jersey",id:"NJ"}), new ListItem({name:"New Mexico",id:"NM"}), new ListItem({name:"New York",id:"NY"}), new ListItem({name:"North Carolina",id:"NC"}), new ListItem({name:"North Dakota",id:"ND"}), new ListItem({name:"Northern Mariana Islands",id:"MP"}), new ListItem({name:"Ohio",id:"OH"}), new ListItem({name:"Oklahoma",id:"OK"}), new ListItem({name:"Oregon",id:"OR"}), new ListItem({name:"Pennsylvania",id:"PA"}), new ListItem({name:"Puerto Rico",id:"PR"}), new ListItem({name:"Rhode Island",id:"RI"}), new ListItem({name:"South Carolina",id:"SC"}), new ListItem({name:"South Dakota",id:"SD"}), new ListItem({name:"Tennessee",id:"TN"}), new ListItem({name:"Texas",id:"TX"}), new ListItem({name:"Trust Territories",id:"TT"}), new ListItem({name:"Utah",id:"UT"}), new ListItem({name:"Vermont",id:"VT"}), new ListItem({name:"Virginia",id:"VA"}), new ListItem({name:"Virgin Islands",id:"VI"}), new ListItem({name:"Washington",id:"WA"}), new ListItem({name:"West Virginia",id:"WV"}), new ListItem({name:"Wisconsin",id:"WI"}), new ListItem({name:"Wyoming",id:"WY"})];
  }

  public validate(): ValidationMessage[] {
    let errors: ValidationMessage[] = [];

    let validatedControls: iValidatedControl[] = [];
    if (this.validatedTextBoxes && this.validatedDropDowns) {
      validatedControls = validatedControls.concat(
        this.validatedTextBoxes.toArray(),
      );
      validatedControls = validatedControls.concat(
        this.validatedDropDowns.toArray(),
      );

      errors = this.formValidator.validate(validatedControls);
    }

    return errors;
  }

  public getStreetAddress(): Partial<StreetAddress> {
    return this.data;
  }

  ngOnInit() {
    this.cache.getCountriesList().then((l) => {
      this.countryOptions = l;
    });
    // console.trace("StreetAddressComponent ngOnInit", this.streetAddress);
    if (this.streetAddress != undefined) {
      this.data.city = this.streetAddress.city;
      this.data.country = this.streetAddress.country;
      this.data.postalCode = this.streetAddress.postalCode;
      this.data.state = this.streetAddress.state;
      this.data.street1 = this.streetAddress.street1;
      this.data.street2 = this.streetAddress.street2;

      if (this.streetAddress.country) {
        this.selectedCountry = this.streetAddress.country;
      }
    }
  }

  ngAfterViewInit() {
    if (this.ddlState && this.data.country) {
      this.ddlState.lookupOptions(this.data.country);
    }
  }

  /*
  public getData(address: Partial<StreetAddress>) {
    address.city = this.data.city;
    address.country = this.selectedCountry;
    address.postalCode = this.data.postalCode;
    address.recipientLine1 = this.data.recipientLine1;
    address.state = this.data.state;
    address.street1 = this.data.street1;
    address.street2 = this.data.street2;
  }
    */

  handleAddressChanged() {
    this.addressUpdated.emit(this.data);
  }

  onCountryChange(value: string) {
    if (this.ddlState && this.data.country) {
      this.ddlState.lookupOptions(this.data.country);
    }

    if (this.txtPostalCode) {
      if (this.data.country == 'CA') {
        this.txtPostalCode.type = this.inputTextModes.PostalCodeCAN;
        this.stateLabel = 'Province';
      } else {
        this.txtPostalCode.type = this.inputTextModes.PostalCodeUS;
        this.stateLabel = 'State';
      }
    }

    this.cache.getStatesList(this.data.country).then((l) => {
      this.stateOptions = l;
    });

    this.handleAddressChanged();
  }

  getFloatLabelValue(): FloatLabelType {
    return 'auto';
  }

  public formatAddress() {
    /*
    if (this.streetAddress != undefined) {
      return this.data.street1 + (this.data.street1 != '' ? "<br/>" : "")
      + this.data.street2  + (this.data.street2 != '' ? "<br/>" : "")
      + this.data.city + (this.data.city != '' ? ", " : "") + this.data.state + " " + this.data.postalCode + (this.data.postalCode != '' ? "<br/>" : "")
      + this.data.country;
    }
    */
    if (this.data != undefined) {
      return (
        this.data.street1 +
        (this.data.street1 != '' ? '<br/>' : '') +
        this.data.street2 +
        (this.data.street2 != '' ? '<br/>' : '') +
        this.data.city +
        (this.data.city != '' ? ', ' : '') +
        this.data.state +
        ' ' +
        this.data.postalCode +
        (this.data.postalCode != '' ? '<br/>' : '') +
        this.data.country
      );
    } else {
      return '';
    }
  }
}
